import { api } from '@/constants'
import { getAuthHeader, serializeQueryParams } from '@/util'
import baseURL from '@/service/api'

const assignment = {
  pickupAssignmentList: params => {
    const url = api.assignment.pickup + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  pickupAssignmentDetail: pickupId => {
    const url = api.assignment.pickupDetail(pickupId)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  driverAssignmentList: (partnerId, params) => {
    const url = api.assignment.driver(partnerId) + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  nearByCouriers: (pickupId, params) => {
    const url = api.assignment.nearByCouriers(pickupId) + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  assignCourier: (pickupId, payloads) => {
    const url = api.assignment.assignCourier(pickupId)
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  }
}
export default assignment
